<template>
  <div>
  	<div  class="filter-wrap">
  		<span>选择日期：</span>
	  	<el-date-picker
	      v-model="dateValue"
	      type="datetimerange"
	      range-separator="~"
	      start-placeholder="开始日期"
	      end-placeholder="结束日期"
	      value-format="yyyy-MM-dd HH:mm:ss"
	      @change="dateValueChange"
	    >
	    </el-date-picker>
		<el-input v-model="search_value" placeholder="请输入手机号或订单搜索" class="searchInput" clearable></el-input>
		<el-button type="primary" @click="searchOrder">搜索</el-button>
	  </div>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="code"
		      label="流水号"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      prop="title"
		      label="备注"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      label="交易类型"
		      align="center"
        >
          <template slot-scope="scope">
          	<span v-if="scope.row.type === '1'">收入</span>
          	<span v-if="scope.row.type === '2'">支出</span>
          </template>
		    </el-table-column>
		    <el-table-column
		      label="金额"
		      align="center"
        >
          <template slot-scope="scope">
          	<span v-if="scope.row.type === '1'">+{{scope.row.price}}</span>
          	<span v-if="scope.row.type === '2'">-{{scope.row.price}}</span>
          </template>
		    </el-table-column>
			
			<el-table-column
			      prop="desc"
			      label="描述"
			      align="center"
			>
			    </el-table-column>
				
		    <el-table-column
		      prop="create_time"
		      label="时间"
		      align="center"
        >
		    </el-table-column>
		  </el-table>
			  <common-pagination
		    :total="total"
	      :page_size="page_size"
		    @size-change="handelPagesizeChange"
		    @page-change="handlePageChange"
		  ></common-pagination>
    </div>
  </div>
</template>

<script>
import { platformFlow } from '@/api/finance-manage';
import CommonPagination from '@/components/CommonPagination';

export default {
  name: 'platformflow',
  data() {
  	return {
  		tableData: [],
		keyword_search: '',
		search_value: '',
  		page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
  		start_time: '',
  		end_time: '',
  		dateValue: [],
  	}
  },
  mounted() {
    this.getPlatformFlow();
  },
  components:  {
  	CommonPagination,
  },
  methods: {
    async getPlatformFlow() {
      let postData = {
      	page_index: this.page_index,
      	page_size: this.page_size,
      	start_time: this.start_time,
      	end_time: this.end_time,
		keyword_search: this.keyword_search
      };
      const { status, data } = await platformFlow(postData);
      if ( status !== 200 ) return
        console.log(data, '流水')
      this.total = data.total;
      this.tableData = data.data;
    },
    dateValueChange(val) {
    	this.start_time = val ? val[0] : '';
    	this.end_time = val ?  val[1] : '';
    	this.getPlatformFlow();
    },
	searchOrder() {
	    this.keyword_search = this.search_value;
		this.selectted_project = '';
	    this.getPlatformFlow();
	},
    handelPagesizeChange(size) {
    	this.page_size = size;
    	this.getPlatformFlow();
    },
    handlePageChange(page) {
      this.page_index = page;
      this.getPlatformFlow();
    } 
  }
}
</script>

<style lang="less" scoped>
.table-wrap {
  margin-top: 30px;
}
.filter-wrap {
    display: flex;
    .filter-item {
        margin-right: 20px;
    }
}
.searchInput {
    width: 200px;
	margin-left: 20px;
    margin-right: 20px;
}
</style>
